import {
  Image,
  StyleSheet,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { useDispatch, useSelector } from "react-redux";
import BottomSheetModal from "../BottomSheetModal";
import { Colors } from "colors";
import VText from "components/VText";
import Svg, { Circle, Path } from "react-native-svg";
import { ActivityIndicator } from "react-native";
import { getSimilarProducts } from "src/redux/reducers/chatSlice";
import { Link } from "expo-router";
import { Svg as SvgIcon } from "assets/svg";
import { useLocalSearchParams } from "expo-router";

export default React.forwardRef((props, ref) => {
  const { height, width } = useWindowDimensions();
  const _bottomSheetRef = useRef();
  const [similarProducts, setSimilarProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  React.useImperativeHandle(ref, () => ({ show, hide }), []);
  const dispatch = useDispatch();
  const local = useLocalSearchParams();
  const gender = local?.gender ?? "female";

  const show = () => {
    _bottomSheetRef?.current?.show();
  };
  const hide = () => {
    _bottomSheetRef?.current?.hide();
    if (props?.setIsVisible) {
      props?.setIsVisible(false);
    }
  };
  let isVisible = (props?.isVisible == undefined) ? true : props?.isVisible ;

  useEffect(() => {
    if (props?.product?.id && isVisible === true) {
      setIsLoading(true);
      dispatch(
        getSimilarProducts({ productId: props?.product?.id, gender: gender })
      ).then((res) => {
        setIsLoading(false);
        setSimilarProducts(res.payload.data);
      });
    }
  }, [props]);




  const renderSimilarProducts = (product) => {
    return (
      <Link
        target="blank"
        href={`${gender == "men" ? "/men" : ""}/product/${
          product?.productId || product?.id
        }/${product?.brandName}/${product?.productName}`?.replaceAll(" ", "-")}
        style={{ width: "32%" }}
      >
        <Image
          source={{ uri: product?.imageUrls[0] }}
          style={{ width: "100%", height: hp(300) }}
        />
        <View style={{ paddingTop: spH(10), paddingBottom: spH(10) }}>
          <VText
            style={{
              fontSize: fp(14),
              fontWeight: "600",
              color: Colors.black,
              marginBottom: spH(5),
            }}
          >
            {product?.brandName}
          </VText>
          <VText
            numberOfLines={2}
            style={{ marginBottom: spH(5), minHeight: spH(35) }}
          >
            {product?.productName}
          </VText>
          <VText>${product?.productPrice}</VText>
        </View>
      </Link>
    );
  };

  return (
    <BottomSheetModal
      MAX_HEIGHT_PERC={1}
      START_PERC={1}
      ref={_bottomSheetRef}
      hideLine
      containerStyle={{
        backgroundColor: "transparent",
        zIndex: 100,
      }}
    >
      <TouchableOpacity
        style={{
          backgroundColor: "transparent",
          width,
          height,
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          zIndex: 100,
          cursor: "auto",
        }}
        activeOpacity={1}
        onPress={() => _bottomSheetRef?.current?.hide()}
      >
        <TouchableOpacity
          style={{
            width: wp(780),
            height: hp(750),
            backgroundColor: "#fff",
            cursor: "auto",
            overflowX: "hidden",
          }}
          activeOpacity={1}
        >
          <TouchableOpacity
            onPress={() => _bottomSheetRef?.current?.hide()}
            activeOpacity={0.8}
            style={{
              position: "absolute",
              right: 20,
              top: 20,
              zIndex: 100,
            }}
          >
            <Image
              source={SvgIcon.closeIcon}
              style={{ width: wp(25), height: wp(25) }}
            />
          </TouchableOpacity>

          <View>
            <View
              style={{
                flex: 1,
                justifyContent: "center",
                alignItems: props?.product?.productName ? "left" : "center",
                padding: spH(20),
              }}
            >
              <VText
                style={{
                  fontSize: fp(24),
                  fontWeight: "450",
                  marginBottom: spH(20),
                  color: Colors.black,
                }}
              >
                {props?.product?.productName
                  ? "Similar Products"
                  : "View Similar"}
              </VText>
              {props?.product?.productName && (
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: spH(10),
                    marginBottom: spH(20),
                  }}
                >
                  <Image
                    source={{ uri: props?.product?.imageUrls[0] }}
                    style={{ width: wp(86), height: hp(110) }}
                  />
                  <View style={{ flex: 1 }}>
                    <VText
                      style={{
                        fontSize: fp(14),
                        fontWeight: "600",
                        color: Colors.black,
                        marginBottom: spH(5),
                      }}
                    >
                      {props?.product?.brandName}
                    </VText>
                    <VText numberOfLines={2} style={{ marginBottom: spH(5) }}>
                      {props?.product?.productName}
                    </VText>
                    <VText>${props?.product?.productPrice}</VText>
                  </View>
                </View>
              )}

              <View
                style={{
                  flex: 1,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {isLoading ? (
                  <ActivityIndicator size="large" color={Colors.primary} />
                ) : (
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: spH(10),
                      flexWrap: "wrap",
                      justifyContent: "flex-start",
                      width: wp(750),
                    }}
                  >
                    {similarProducts.length > 0 ? (
                      similarProducts.map((product) =>
                        renderSimilarProducts(product)
                      )
                    ) : (
                      <VText>No similar products found</VText>
                    )}
                  </View>
                )}
              </View>
            </View>
          </View>
        </TouchableOpacity>
      </TouchableOpacity>
    </BottomSheetModal>
  );
});

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.white,
    borderRadius: 8,
    width: wp(309),
  },
  image: {
    width: wp(309),
    height: hp(199),
  },
});
